<template>
<div class="access">
  <div class="access__container">
    <h1 class="access__title">RECUPERAR ACCESO</h1>
    <p class="access__text">Ingresa tu email, te enviaremos instrucciones para recuperar tu acceso</p>
    <form class="form" @submit.prevent="recovery">
      <div class="form__fieldset">
        <div class="form__container form__container--wide">
          <label for="email" class="form__label">Email</label>
          <input type="text" class="form__input" name="email" id="email" v-model="element.email" v-validate="validation.email">
          <span v-show="errors.has('email')" class="form__alert">{{ errors.first('email') }}</span>
        </div>
        <input type="submit" class="btn btn__default btn--regular" value="Recuperar">
        <router-link class="btn btn__transparent btn--regular" :to="{name: 'login'}">Iniciar Sesión</router-link>
        <router-link class="btn btn__transparent btn--regular" :to="{name: 'reset'}">Ya tengo mi código de recuperación</router-link>
      </div>
    </form>
  </div>
</div>
</template>

<script>
import httpService from '@/api/request'
export default {
  mixins: [httpService],
  data: function () {
    return {
      element: {
        email: null
      },
      validation: {
        email: 'required|email'
      }
    }
  },
  methods: {
    recovery: function () {
      this.$validator.validateAll()
        .then(
          response => {
            if (response) {
              let httpRequest = {
                module: 'recovery',
                element: this.element,
                params: ''
              }
              this.post(httpRequest)
                .then(
                  () => {
                    this.$router.push({name: 'reset'})
                    this.$store.commit('notificate', {
                      title: 'SOLICITUD PROCESADA',
                      text: 'Su peticion a sido procesada correctamente, siga las intrucciones en el mensaje que le hemos enviado',
                      type: 'success'
                    })
                  }
                )
                .catch(
                  () => {
                    this.$store.commit('notificate', {
                      title: 'SOLICITUD NO PROCESADA',
                      text: 'Ha ocurrido un error al procesar su petición, por favor, intente de nuevo.',
                      type: 'error'
                    })
                  }
                )
            } else {
              this.$store.commit('notificate', {
                title: 'CAMPOS REQUERIDOS',
                text: 'Por favor, revise el formulario, existen campos requeridos que no han sido completados.',
                type: 'warn'
              })
            }
          }
        )
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../../assets/sass/objects/_btns"
@import "../../assets/sass/components/_access"
@import "../../assets/sass/components/layout/_forms"
</style>



// WEBPACK FOOTER //
// src/components/access/recovery.vue